import {useFeatureFlags} from '@smart/feature-app';
import type {Tag} from '@smart/web-components';
import {ColorTile, getHexFromColorCode} from '@smart/web-components';
import classNames from 'classnames';
import * as React from 'react';
import {UsedFeatureFlags} from '../../constants/common';
import type {FacetOption} from '../facet-panel';
import {TagWithImg} from '../tag-with-image';
import styles from './index.module.scss';

export type Tag = FacetOption;

export type FilterTagProps = {
  className?: string;
  tags: Tag[];
  ariaLabel: string;
  handleRemove: (option: FacetOption) => void;
};
const renderColorTileForTag = (facetOption: Tag) => {
  const [primary, secondary] = facetOption.id.split(`/`);
  const primaryColorHex = getHexFromColorCode(primary);
  const secondaryColorHex = getHexFromColorCode(secondary, ``);

  if (!primary && !secondary) return null;
  return (
    <ColorTile
      className={styles.colorTileForTag}
      id={facetOption.id}
      primaryColor={primaryColorHex}
      secondaryColor={secondaryColorHex}
      disabled={false}
      selected={false}
      titleText={facetOption.displayName}
    />
  );
};

export const FilterTags = ({
  className,
  tags,
  ariaLabel,
  handleRemove,
}: FilterTagProps) => {
  const {enabled: enableFilters} = useFeatureFlags(
    UsedFeatureFlags.ENABLE_STOCK_SEARCH_FILTER_V2,
  );
  const filterTags = classNames(styles.filterTags, {
    [`${styles.filterTagsEnable}`]: enableFilters,
  });
  return (
    <ul className={[filterTags, className].filter(Boolean).join(` `)}>
      {tags.map((option) => {
        const isColor = Object.prototype.hasOwnProperty.call(
          option,
          `imageUrl`,
        );

        return (
          <li key={`filter-tag-${option.id}`} className={styles.tagItem}>
            <TagWithImg
              label={
                isColor ? (
                  <span className={styles.colorTileForTagWrapper}>
                    {renderColorTileForTag(option)}
                    <span className={styles.displayText}>
                      {option.displayName}
                    </span>
                  </span>
                ) : (
                  option.displayName
                )
              }
              variant={`close-without-circle--small`}
              removable={{
                ariaLabel,
                onClick: () => handleRemove(option),
              }}
            />
          </li>
        );
      })}
    </ul>
  );
};
